/* src/app/features/honra/validacao-scr/validacao-scr-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=validacao-scr-detalhe.component.css.map */
